import type { EnumNameConfig } from '@ps-smart-cp/ppfw-client';
import { Locale } from '@ps-smart-cp/ppfw-client';
import type { PaidClass } from './PaidClass.enum';

const paidClassConfig = {
  notYet: new Map([[Locale.ja, '未']]),
  completed: new Map([[Locale.ja, '済']]),
} satisfies EnumNameConfig<typeof PaidClass>;

export { paidClassConfig };
